module.exports = __webpack_public_path__ + "static/media/s1.25adca35.webp";